import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Heading,
  Flex,
} from "@chakra-ui/react";

const FaqItem = ({ item }) => {
  return (
    <AccordionItem>
      <h1>
        <AccordionButton>
          <Flex
            as="div"
            flex="1"
            boxSize={20}
            alignItems="center"
          >
            <Heading as="h3" size="md">
              {item.title}
            </Heading>
          </Flex>
          <AccordionIcon />
        </AccordionButton>
      </h1>
      <AccordionPanel pb={4}>{item.content}</AccordionPanel>
    </AccordionItem>
  );
};

export default FaqItem;
